export interface IEnumValue {
  key?: number | string;
  name: string;
  titleName: string;
  snakeCaseName: string;
}
